import { render, staticRenderFns } from "./SocialPostingLatestPostsCard.vue?vue&type=template&id=1ff745ca"
import script from "./SocialPostingLatestPostsCard.vue?vue&type=script&lang=ts"
export * from "./SocialPostingLatestPostsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports